/**
 * MarkerPickerWrapper Component
 * Floating marker type picker wrapper
 */

import React from 'react';
import { AnimatePresence } from 'framer-motion';
import { MarkerTypePicker, MARKER_TYPES } from '../../MarkersRegions';
import { toast } from 'sonner';

export const MarkerPickerWrapper = ({
  isOpen,
  pendingMarkerTime,
  markerPickerPosition,
  addMarker,
  onClose,
}) => {
  return (
    <AnimatePresence>
      {isOpen && pendingMarkerTime !== null && (
        <MarkerTypePicker
          position={markerPickerPosition}
          onSelect={(type) => {
            addMarker(pendingMarkerTime, type);
            toast.success(`${MARKER_TYPES[type].name} marker added`);
          }}
          onClose={onClose}
        />
      )}
    </AnimatePresence>
  );
};

export default MarkerPickerWrapper;
